import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import HowToHelp from "../components/shared/how-to-help"
import InnerBanner from "../components/shared/inner-banner"
import InnerIntro from "../components/shared/inner-intro"
import banner from "../images/foster-banner-bg.jpg"
import Sections from "../components/contact/sections"
import FosterButtons from "../components/shared/foster-buttons"
const SurrenderPage = () => {

  return <Layout colored_header={true}>
    <Seo title="Surrender My Labrador Retriever" />
    <InnerBanner image={banner} title="Surrender My Labrador Retriever" />
   
    
    <Sections.Section2 innerClassName={'full-width'} />
    
  </Layout>
}

export default SurrenderPage